export const nameRegex = /^[^.\\/]+$/;
